import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Output, EventEmitter } from '@angular/core';
import { Router, Route } from "@angular/router";
import { ApiService } from 'src/app/services/api/api.service';

@Component({
    selector: 'app-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {

    loading: boolean = false;
    search: any = '';
    results: any = [];
    pageResults: any = [];
    instituteResults: any = [];
    error: boolean = false;
    pages: any = [
        {
            title: 'Account',
            tags: ['account', 'my account', 'profile'],
            path: '/my-account'
        },
        {
            title: 'Cart',
            tags: ['cart', 'my cart', 'checkout'],
            path: '/cart'
        },
        {
            title: 'Forgot Password',
            tags: ['password', 'forgot', 'forgot password', 'reset password'],
            path: '/forgot-password'
        },
        {
            title: 'Timetable',
            tags: ['timetable', 'schedule', 'calendar'],
            path: '/timetable'
        },

    ];

    @Output() searchToggleEvent = new EventEmitter<string>();

    constructor(
        private router: Router,
        private api: ApiService,
        private cd: ChangeDetectorRef,
    ) {
    }

    ngOnInit(): void {

        this.printpath('', this.router.config);

    }

    printpath(parent: String, config: Route[]) {

        for (let i = 0; i < config.length; i++) {
            const route = config[i];
            if (route.children) {
                const currentPath = route.path ? parent + '/' + route.path : parent;
                this.printpath(currentPath, route.children);
            }
        }

    }

    toggleSearch() {

        this.searchToggleEvent.emit('');

    }

    bodyClick(event) {

        event?.target?.classList.forEach(cls => {
            if (cls == 'search-comp') {
                this.toggleSearch();
            }
        });

    }

    /**
     * Do the search
     */
    doSearch() {

        this.pageResults = [];
        this.instituteResults = [];
        this.error = false;

        if (this.search) {
            this.loading = true;

            this.pages.forEach(page => {
                page.tags.forEach(tag => {
                    if (tag.toLowerCase().includes(this.search.toLowerCase())) {
                        if (this.pageResults.indexOf(page) === -1) {
                            this.pageResults.push(page);
                        }
                    }

                });

            });

            this.fetchPages(this.search);
            this.fetchCourses(this.search);
        }

    }

    async fetchPages(searchTerm = '') {

        await this.api.fetch_pages('?query%5BgeneralSearch%5D=' + searchTerm)
            .subscribe(res => {
                res.data.items.forEach(page => {
                    if ((page.title.toLowerCase().includes(searchTerm.toLowerCase()))) {
                        if (this.pageResults.indexOf(page) === -1) {
                            this.pageResults.push(page);
                        }
                    }
                });

                console.log('pages', this.pageResults);

                this.loading = false;
                this.cd.detectChanges();
            }, (err) => {
                console.log(err);
                this.error = true;
            });

    }

    /**
     * Fetch all courses.
     */
    async fetchCourses(searchTerm = '') {

        await this.api.fetch_institutions()
            .subscribe(res => {

                res.data.items.forEach(institute => {
                    if ((institute.title.toLowerCase().includes(searchTerm.toLowerCase())) || (institute.short_title.toLowerCase().includes(searchTerm.toLowerCase()))) {
                        if (this.instituteResults.indexOf(institute) === -1) {
                            this.instituteResults.push(institute);
                        }
                    }
                });

                if (this.instituteResults.length == 0 && this.pageResults.length == 0) {
                    this.error = true;
                }

                this.loading = false;
                this.cd.detectChanges();

            }, (err) => {
                console.log(err);
                this.error = true;
            });

    }

}
